module.exports = __webpack_public_path__ + "static/media/testimonial-fire-2.66563cf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/testimonial-fire-2.jpg
// module id = 1189
// module chunks = 0